import { render, staticRenderFns } from "./DropdownReturnOrder.vue?vue&type=template&id=2248258d&"
import script from "./DropdownReturnOrder.vue?vue&type=script&lang=js&"
export * from "./DropdownReturnOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports